import { render, staticRenderFns } from "./modification-items.vue?vue&type=template&id=7cffd030&"
import script from "./modification-items.vue?vue&type=script&lang=js&"
export * from "./modification-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports